export default "__VITE_ASSET__BkPulzEB__"